((sectionClass) => {
	'use strict';

	//
	class Handler {
		/**
		 * Init
		 */
		constructor(rootEl, rootClass) {
			this.loadingClass = 'loading';
			this.loadMoreClass = 'load-more-button-width-display-number';
			this.buttonWrapClass = `${this.loadMoreClass}__button-wrap`;
			this.buttonClass = `${this.loadMoreClass}__button`;
			this.gridClass = `${rootClass}__grid`;

			rootEl.addEventListener('click', this.#loadMoreClicked.bind(this));
		}

		/**
		 * User has clicked the load more button
		 *
		 * @param     {MouseEvent} event    An event raised by a user action
		 * @return    {void}
		 */
		async #loadMoreClicked(event) {
			// Make sure we have the correct element
			const matchesSelector = `.${this.buttonWrapClass}`;
			if(
				!event.target.matches(matchesSelector) &&
				!event.target.matches(`${matchesSelector} *`)
			) {
				return;
			}

			// Don't execute the click
			event.preventDefault();

			// Find elements
			const buttonEl = event.target.closest(matchesSelector);
			const wrapperEl = buttonEl?.closest(`.${this.buttonWrapClass}`);
			const sectionEl = buttonEl?.closest('section');
			if (
				!(wrapperEl instanceof HTMLElement) ||
				!(sectionEl instanceof HTMLElement)
			) {
				return;
			}

			// Show the loading indicator
			wrapperEl.classList.add(this.loadingClass);

			// Update the page from a remote URL
			const markup = await this.#fetchMarkup(wrapperEl.dataset?.nextUrl);
			const remoteDocument = this.#parseMarkup(markup);
			this.#updatePageElements(remoteDocument, sectionEl);

			// Hide the loading indicator
			wrapperEl.classList.remove(this.loadingClass);
		}

		/**
		 * Fetch a HTML document
		 *
		 * @param     {string} url    The URL to fetch
		 * @return    {string}
		 */
		async #fetchMarkup(url) {
			return await fetch(url).then(o => o.text());
		}

		/**
		 * Parse a HTML document
		 *
		 * @param     {string} htmlString    A HTML string to parse
		 * @return    {DOMParser}
		 */
		#parseMarkup(htmlString) {
			const parser = new DOMParser();
			return parser.parseFromString(htmlString, 'text/html');
		}

		/**
		 * Update/swap local elements using remote document
		 *
		 * @param     {DOMParser}   remoteDocument    A parsed HTML document
		 * @param     {HTMLElement} localSectionEl    A local block section
		 * @return    {void}
		 */
		#updatePageElements(remoteDocument, localSectionEl) {
			// Find elements in the remote response
			const remoteSectionEl = remoteDocument.getElementById(localSectionEl.getAttribute('id'));
			const remotePosts = Array.from(remoteSectionEl.querySelectorAll(`.${this.gridClass} > *`));
			const remoteLoadMoreEl = remoteSectionEl.querySelector(`.${this.loadMoreClass}`);

			// Find local elements
			const localGridEl = localSectionEl.querySelector(`.${this.gridClass}`);
			const localLoadMoreEl = localSectionEl.querySelector(`.${this.loadMoreClass}`);

			// Add remote posts to local grid
			const fragment = new DocumentFragment();
			remotePosts.forEach(o => fragment.appendChild(o));
			localGridEl.appendChild(fragment);

			// Replace local load more button with remote
			localLoadMoreEl.replaceWith(remoteLoadMoreEl);
		}
	}

	// Init a handler for each block instance
	const sectors = Array.from(document.querySelectorAll(`section.${sectionClass}`));
	sectors.forEach((o) => new Handler(o, sectionClass));
})('news-and-media');
